module.exports = "/_next/static/images/image1AboutUs-9f2d35ca2c7b0692f1f9fa785edf2c95.jpg.webp";